
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import store from './store'
import elementEnLocale  from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
Vue.config.productionTip = false
// Vue.use(ElementUI, {enLocale});

/*引入axios*/
import Axios from 'axios'
Vue.prototype.axios = Axios;

import VueI18n from 'vue-i18n'//引入对应的组件
Vue.use(VueI18n);//挂载使用i18n的插件

import {enm} from './lang/en'
import {zhm} from './lang/zh'
// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
  //基本常见，多语言网页,使用this.$i18n.locale="zh";可以修改对应的语言模式，其处理一般放在一个lang文件下
  //封装处理多个语言, 大小写均可，这就是messages对象里面的key
  locale: localStorage.getItem('lang') || 'CN',
  // 首选语言缺少翻译时要使用的语言。如果某个语言环境没有设置变量，就会使用fallbackLocale环境下的对应变量
  fallbackLocale: 'CN',
  //抑制警告
  silentFallbackWarn: true,
  // 语言对照表
  messages: {
    US: {
      msg: enm,...elementEnLocale

    },
    CN: {
      msg: zhm,...elementZhLocale
    },

  },

});

Vue.use(ElementUI,{
  i18n:(key,value)=>i18n.t(key,value)
})
import dispatchEventStroage from './utils/watchLocalStorage'
Vue.use(dispatchEventStroage);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js